module.exports = __webpack_public_path__ + "static/website-art-4fd493bdcc44fa5bc0add0d8bb028ebb.jpg";